import React, { useState } from 'react';
import { BadgeSystem } from '@/components/badges/BadgeSystem';
import { BadgeCreator } from '@/components/badges/BadgeCreator';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { useRole } from '@/hooks/useRole';

export default function Badges() {
  const [showCreator, setShowCreator] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const { isAdmin, isCoordinator, isPrincipal } = useRole();
  
  const canCreateBadges = isAdmin || isCoordinator || isPrincipal;

  const handleBadgeCreated = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="container mx-auto py-8 px-4">
      <div className="mb-8 flex justify-between items-start">
        <div>
          <h1 className="text-3xl font-bold">Badges & Achievements</h1>
          <p className="text-muted-foreground mt-2">
            Track your professional development progress and earn badges for your accomplishments.
          </p>
        </div>
        
        {canCreateBadges && (
          <Button onClick={() => setShowCreator(true)} className="flex items-center gap-2">
            <Plus className="h-4 w-4" />
            Create Badge
          </Button>
        )}
      </div>
      
      <BadgeSystem key={refreshKey} />
      
      {canCreateBadges && (
        <BadgeCreator
          open={showCreator}
          onOpenChange={setShowCreator}
          onBadgeCreated={handleBadgeCreated}
        />
      )}
    </div>
  );
}